import { render } from "./EmailVerification.vue?vue&type=template&id=44b2d0c2"
import script from "./EmailVerification.vue?vue&type=script&lang=js"
export * from "./EmailVerification.vue?vue&type=script&lang=js"
script.render = render

export default script